import { utilities } from '@cornerstonejs/metadata';
export default utilities.imageIdToURI;
